import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jbt25unvjp: FaireBrandEntity = {
  token: "b_jbt25unvjp",
  type: "brand",
  name: "Gooddiy",
  avatarUrl:
    "https://cdn.faire.com/fastly/0eb448ced1d5d4bde24167efa75a4e7c4c497d7b9cf773393f05f15bf9096542.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a3e5da964f982bb60ffd8544fd55d4018ca11e0741cc29876ba19fd454e25ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0eb448ced1d5d4bde24167efa75a4e7c4c497d7b9cf773393f05f15bf9096542.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a3e5da964f982bb60ffd8544fd55d4018ca11e0741cc29876ba19fd454e25ac.jpeg",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 69,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "We are located in Philadelphia, specializing in the design and production of various gifts, hoping to bring more fun to your life.Buy our products and let every day be full of surprises and inspiration. Excellent quality and unique design make our products the best partner in your life.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:43.010Z",
    importedBy: "entity-db-cli",
  },
};
